import { styled } from '../../../theme/styled';

export const TabPanel = styled('div', {
  name: 'Tabs',
  slot: 'Panel',
})<{ ownerState: { isActive: boolean } }>(({ ownerState }) => {
  return {
    visibility: ownerState.isActive ? 'visible' : 'hidden',
    position: ownerState.isActive ? 'relative' : 'absolute',
    top: 0,
    left: 0,
    width: '100%',
  };
});
